import { IP_INDUSTRIES, IP_JURISDICTIONS, IP_SERVICES } from "./index";
import { buildLegalClusterQA, toAxis, type WaveQA } from "../_qa/legal-clusters";

export type IpQA = WaveQA;

export const IP_REVIEWED_TH = "สิงหาคม 2569";
export const IP_REVIEWED_ISO = "2026-08-07";

export const IP_QA: IpQA[] = buildLegalClusterQA({
  prefix: "ip",
  clusterTh: "งานทรัพย์สินทางปัญญา (เครื่องหมายการค้า สิทธิบัตร ลิขสิทธิ์)",
  authorityTh: "กรมทรัพย์สินทางปัญญาหรือสำนักงานทรัพย์สินทางปัญญาปลายทาง",
  reviewedTh: IP_REVIEWED_TH,
  volatileNote:
    "ประเภทสินค้า/บริการ ค่าธรรมเนียมราชการ และระยะเวลาพิจารณาเปลี่ยนได้ ควรยืนยันกับกรมทรัพย์สินทางปัญญาก่อนยื่น",
  topics: toAxis(IP_SERVICES),
  extraTopics: [...toAxis(IP_INDUSTRIES, "ind"), ...toAxis(IP_JURISDICTIONS, "jur")],
});

export const IP_QA_BY_SLUG: Record<string, IpQA> = Object.fromEntries(
  IP_QA.map((qa) => [qa.slug, qa]),
);

export const IP_QA_COUNT = IP_QA.length;
